// Peças da liga usadas em várias telas: a divisão com a barra de progresso e os pontos
// do fim de partida. A marca do patrocinador (faixa, verso, feltro e tela de entrada) fica em marca.tsx, que o painel
// admin também usa na prévia.
import { useEffect } from 'react';
import { DIVISOES, type GanhosDaPartida, divisaoNaTela } from '@truco6/gamificacao';
import type { DivisaoNaTela, SituacaoLimite } from '../comum/api.ts';
import { medirUmaVez } from '../comum/medicao.ts';

export { EntradaPatrocinada, estiloDaMarca, FaixaLiga, IconeTrofeu, MarcaNoFeltro, periodoDaSemana, tempoAte, versoDaLiga } from './marca.tsx';

export function BarraDivisao({ d, compacta = false }: { d: DivisaoNaTela; compacta?: boolean }) {
  const { pd, meta } = d.progresso;
  return (
    <div className={'barra-divisao' + (compacta ? ' compacta' : '')}>
      <div className="divisao-cab">
        <span className="divisao-emoji" aria-hidden="true">{d.emoji}</span>
        <b>{d.rotulo}</b>
        <span className="divisao-pd">{meta === null ? `${pd} PD` : `${pd}/${meta} PD`}</span>
      </div>
      {meta !== null && (
        <div className="trilho" role="progressbar" aria-label={`Divisão ${d.rotulo}`} aria-valuemin={0} aria-valuemax={meta} aria-valuenow={pd}>
          <i style={{ width: `${Math.min(100, (pd / meta) * 100)}%` }} />
        </div>
      )}
    </div>
  );
}

// Mesa que começa com 3 bots ou mais (menos de 4 pessoas) não pontua: a nota da sala de espera, de criar sala e da busca.
export const NOTA_SEM_RANKING = 'Com 3 bots ou mais, a partida não vale ranking nem divisão.';

const comSinal = (n: number) => (n > 0 ? '+' : n < 0 ? '−' : '') + Math.abs(n);

// Fim de partida, em qualquer sala que pontua: pontos do ranking, PD e a barra da divisão (canvas F11). Mesa que
// começou com 3 bots ou mais mostra só a linha de que não vale ranking nem divisão. Chega logo depois do fim.
export function LigaNoFim({ ganhos }: { ganhos: GanhosDaPartida | null }) {
  const l = ganhos?.liga ?? null;
  const subiu = l?.divisao.subiu ? DIVISOES[l.divisao.depois.divisao]!.id : null;
  useEffect(() => {
    if (subiu && ganhos) medirUmaVez('divisao:' + ganhos.partida, 'divisao_mudou', { divisao: subiu });
  }, [subiu]);
  if (ganhos?.semRanking) return <p className="nota sem-ranking" role="status">Mesa com 3 bots ou mais não vale ranking nem divisão.</p>;
  if (!l) return ganhos ? null : <div className="cartao liga-fim" role="status"><p className="nota">Somando os pontos...</p></div>;
  const depois = divisaoNaTela(l.divisao.depois);
  return (
    <div className="cartao liga-fim" role="status">
      <div className="liga-fim-cab">
        <p><b className={l.pontos < 0 ? 'neg' : undefined}>{comSinal(l.pontos)} pts</b><span>no ranking</span></p>
        <p><b className={l.pd < 0 ? 'neg' : undefined}>{comSinal(l.pd)} PD</b><span>na divisão</span></p>
      </div>
      {l.divisao.subiu && <p className="subiu">Subiu para {depois.rotulo}! {depois.emoji}</p>}
      <BarraDivisao d={depois} />
    </div>
  );
}

